module.exports = __webpack_public_path__ + "static/media/hey-kitchen-backend-order-details.b035afdf.png";